import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Site } from 'src/app/admin/1.tv/sites/sites.model';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  @Input() dividers = true;
  @Input() iconSize = 'sm';
  @Input() iconColor = '';
  @Input()sites$: Observable<Site[]>;
  constructor() { }

  ngOnInit() {
  }

}
